import { Button, ButtonColor, Modal } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "../Forms/components/ButtonMenu.js";

interface UserActionModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  buttonProps?: {
    cancelText?: string;
    submitText?: string;
    submitColor?: string;
  };
  title: string;
  body: string;
}

const UserActionModal: React.FC<UserActionModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  buttonProps,
  title,
  body,
}) => {
  const handleSubmit = async () => {
    onSubmit?.();
    onClose?.();
  };

  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose} style={{ maxWidth: 500 }}>
      <Modal.Title>{title}</Modal.Title>
      <div style={{ fontWeight: 600, margin: "20px 0px" }}>{body}</div>
      <ButtonMenu>
        <Button size="xs" variant="contained" onClick={handleCancel}>
          {buttonProps?.cancelText || "Cancel"}
        </Button>
        <Button
          size="xs"
          color={(buttonProps?.submitColor as ButtonColor) || "primary"}
          variant="contained"
          onClick={handleSubmit}
        >
          {buttonProps?.submitText || "Submit"}
        </Button>
      </ButtonMenu>
    </Modal>
  );
};

export default UserActionModal;
